var map = {
	"./chickflick.png": "230a",
	"./clockwork.png": "d974",
	"./drought.png": "9454",
	"./lastlantern.jpg": "e070",
	"./medievalfishing.png": "a7b0",
	"./pathfinder.png": "b808",
	"./polevolt.png": "0a59",
	"./senseshift.png": "c62f",
	"./squire.png": "0128",
	"./tangleroot.png": "f344"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";